<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex md12>
        <material-card color="primary" class="elevation-1 spm_list spmList">
          <template slot="header">

            <div style="display: grid;grid-template-columns: 1fr auto;padding: 0px 10px 0px 0px;">
              <h4 class="title font-weight-light mb-2" v-text="'SPM'" style="padding:10px" />

              <div>

                <v-tooltip bottom>
                  <template slot="activator" slot-scope="{ on }">
                    <v-btn v-on="on" :disabled="!filters.protocol_id.value || !pagination.totalItems" color="pink" dark
                      small v-if="$can('execute', 'export_spm_report_qc')" @click="reportQualityCheck()">
                      QUALITY CHECK
                      <v-icon>mdi-file-excel</v-icon>
                    </v-btn>
                  </template>
                  <span>Export QC listing</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template slot="activator" slot-scope="{ on }">
                    <v-btn v-on="on" :disabled="!filters.protocol_id.value || !pagination.totalItems || !items.some(item => item.status !== 'Canceled')" color="pink" dark
                      small v-if="$can('execute', 'export_spm_report_complete')" @click="exportExcel()">
                      All
                      <v-icon>mdi-file-excel</v-icon>
                    </v-btn>
                  </template>
                  <span>Complete Export</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template slot="activator" slot-scope="{ on }">
                    <v-btn v-on="on" color="pink" dark small @click="newSpmEvent()" v-if="$can('upsert', 'spm')">
                      <v-icon>mdi-plus</v-icon>
                    </v-btn>
                  </template>
                  <span>Add new SPM</span>
                </v-tooltip>

              </div>
            </div>
          </template>

          <v-data-table id="spm_dataTable" :headers="headers" :items="items" :pagination.sync="pagination"
            :rows-per-page-items="[5, 10, 20]" :total-items="totalItems" :loading="loading" prev-icon="mdi-menu-left"
            next-icon="mdi-menu-right" sort-icon="mdi-menu-down">
            <v-progress-linear v-slot:progress color="green" indeterminate></v-progress-linear>

            <template slot="headers" slot-scope="props">
              <tr>
                <th v-for="header in props.headers" :key="header.text" :class="[
                  'column',
                  header.align ? 'text-xs-' + header.align : 'text-xs-left',
                  pagination.descending ? 'desc' : 'asc',
                  header.sortable != false ? 'sortable' : '',
                  header.value === pagination.sortBy &&
                    header.sortable != false ? 'active' : ''
                ]" @click="
                    if (header.sortable != false) {
  changeSort(header.value);
}
  ">
                  <v-icon v-if="header.sortable != false" small>mdi-menu-down</v-icon>
                  <span class="subheading font-weight-dark text-success text-darken-3" v-text="header.text"></span>
                </th>
              </tr>

              <tr class=" lighten-3">
                <th v-for="header in props.headers" :key="header.text">
                  <div v-if="filters.hasOwnProperty(header.value)" style="max-width:200px">
                    <v-text-field :style="filters[header.value].style + ' '" clearable
                      v-if="filters[header.value].type == 'text'" v-model="filters[header.value].value"
                      :placeholder="filters[header.value].placeholder" @input="filterChanged(filters[header.value])" />

                    <v-select :style="filters[header.value].style + ' '" clearable
                      v-if="filters[header.value].type == 'list'" v-model="filters[header.value].value"
                      :items="filters[header.value].list" :item-text="filters[header.value].item_text"
                      :item-value="filters[header.value].item_value" :placeholder="filters[header.value].placeholder"
                      @change="filterChanged(filters[header.value])"></v-select>

                    <v-autocomplete :style="filters[header.value].style + ' '" clearable
                      v-if="filters[header.value].type == 'autocomplete'" v-model="filters[header.value].value"
                      :items="filters[header.value].list" :item-value="filters[header.value].item_value"
                      :item-text="filters[header.value].item_text" :placeholder="filters[header.value].placeholder"
                      @change="filterChanged(filters[header.value])"></v-autocomplete>
                  </div>
                </th>
              </tr>
            </template>

            <template slot="items" slot-scope="{ item }">
              <tr :class="item.is_read ? 'read' : 'unread'">
                <td :class="canceledClass(item)">{{ item.protocol.name }}</td>
                <td class="text-xs-left" :class="canceledClass(item)">
                  <v-tooltip top>
                    <template slot="activator" slot-scope="{ on }">
                      <span v-on="on">{{ item.cin || '-----' }}</span>
                    </template>
                    <span>{{ item.case_type }}</span>
                  </v-tooltip>
                </td>
                <!-- //issue 257 services -->
                <td class="text-xs-left" :class="canceledClass(item)">{{ formatDate(item.report_date) }}</td>
                <!-- //issue 257 services -->
                <td class="text-xs-left" :class="canceledClass(item)">{{ item.patient_id }}</td>
                <td class="text-xs-left" :class="canceledClass(item)">
                  <v-tooltip top min-width='500px'>
                    <template slot="activator" slot-scope="{ on }">
                      <div v-on="on">
                        {{ item.protocol_has_site.code ? item.protocol_has_site.code : '---' }}
                      </div>
                    </template>
                    <span>{{ item.site.name }} ({{ item.site.country }}) - [{{ item.site.code }}]</span>
                  </v-tooltip>
                </td>
                <td class="text-xs-left" :class="canceledClass(item)">{{ item.status }}</td>
                <td class="text-xs-left" :class="canceledClass(item)">
                  <v-icon v-if="item.company_notification_date" color="green">mdi-check</v-icon>
                  <v-icon v-if="item.medical_notification_date" color="green">mdi-check</v-icon>
                </td>

                <td class="text-xs-right">

                  <v-tooltip top>
                    <template slot="activator" slot-scope="{ on }">
                      <a flat @click="upsertPage(item)">
                        <v-icon v-if="$can('upsert', 'spm')" v-on="on" color="primary">mdi-pencil</v-icon>
                        <v-icon v-if="!$can('upsert', 'spm')" v-on="on" color="primary">mdi-eye</v-icon>
                      </a>
                    </template>
                    <span v-if="$can('upsert', 'spm')">Edit SPM event - {{ item.id }}</span><span v-else>View SPM event - {{ item.id }}</span>

                  </v-tooltip>

                  <v-tooltip top v-if="canDelete(item) && item.status != 'Canceled'">
                    <template slot="activator" slot-scope="{ on }">
                      <a flat @click="confirmDelete(item)"  class="ml-2">
                        <v-icon v-on="on" color="primary">mdi-delete-forever</v-icon>
                      </a>
                    </template>
                    <span>Remove SPM Report - {{ item.id }}</span>
                  </v-tooltip>

                  <v-icon v-if="!canDelete(item) && item.status != 'Canceled'" disabled
                    color="primary">mdi-delete-forever</v-icon>

                  <v-tooltip top>
                    <template slot="activator" slot-scope="{ on }">
                      <a flat @click="openAuditTrail(item)" class="ml-2">
                        <v-icon v-on="on" color="primary">mdi-timeline-clock-outline</v-icon>
                      </a>
                    </template>
                    <span>Audit Trail</span>
                  </v-tooltip>
      
                </td>
              </tr>
            </template>
          </v-data-table>
        </material-card>
      </v-flex>


      <v-dialog v-model="confirm_delete_dialog" persistent max-width="500px">
        <material-card color="red" title="Delete SPM Report">
          <v-form ref="form">
            <v-container grid-list-md>
              <v-layout wrap>

                <v-flex md12>
                  Are you sure you want to delete this SPM Report <b>"{{ selectedItem.cin }}" - ({{ selectedItem.id }})</b> ?
                  <br><br>
                </v-flex>

                <v-flex md12>
                  <v-text-field label="Canceled NOTE" v-model="selectedItem.canceled_note" />
                </v-flex>

              </v-layout>
            </v-container>
          </v-form>
          <v-flex xs12 text-xs-right>
            <v-btn class="mx-1 font-weight-light" color="danger" :disabled="!selectedItem.canceled_note"
              @click="remove()">Delete</v-btn>
            <v-btn class="mx-1 font-weight-light" color="primary" @click="closeDelete()">Cancel</v-btn>
          </v-flex>
        </material-card>
      </v-dialog>

      <v-dialog v-model="auditTrail.open" width="1200px">
        <safety-audittrail-timeline v-if='auditTrail.open' entity="spm" :entity_id='auditTrail.entityId' :fields="headers"/>
      </v-dialog>

    </v-layout>
  </v-container>
</template>


<script>
import { subject } from '@casl/ability';
import { normalizeFilters } from "@/utils/filters";
import { getList, remove, upsert } from "@/api/spm";
import { exportExcelSpm, reportQualityCheck } from "@/api/report";
import { filters_store } from "./filters";
//issue 257 services
import moment from 'moment';
//issue 257 services

export default {
  data() {
    return {
      pagination: {
        rowsPerPage: 5,
        page: 1,
        sortBy: "id",
        descending: true
      },
      paginationAlias: {
        protocol_id: "protocol.name",
      },
      auditTrail: {
        open: false,
        entityId: null
      },
      loading: true,
      items: [],
      totalItems: 0,
      confirm_delete_dialog: false,
      selectedItem: {},
      headers: [
        { text: "Protocol", align: "left", value: "protocol_id" },
        { text: "Cin", value: "cin" },
        { text: "Rep.Date", value: "report_date" },
        { text: "Patient", value: "patient_id", sortable: false },
        { text: "Site", value: "site_number", sortable: false },
        { text: "Status", value: "status", sortable: false },
        // { text: "CRF", value: "crf", sortable: false },
        { text: "Sent", value: "sent_to_companies", sortable: false },
        { text: "Actions", value: "actions", sortable: false, align: "right" }
      ],
      filters_store
    };
  },
  computed: {
    filters() {
      this.filters_store['protocol.sponsor_id'] = { value: this.$store.getters.sponsor_id };
      this.filters_store.protocol_id.list = this.$store.getters.protocols;
      return this.filters_store;
    }

  },
  watch: {
    pagination: {
      handler(val, oldVal) {
        if (val.page != oldVal.page || val.rowsPerPage != oldVal.rowsPerPage ||
          val.sortBy != oldVal.sortBy || val.descending != oldVal.descending) {
          this.getData();
        }
      },
      deep: true
    },
    filters: {
      handler(val) {
        this.pagination.page = 1;
        this.getData();
      },
      deep: true
    }
  },
  created() {
    this.$store.dispatch("app/loadSponsors");
    this.$store.dispatch("app/sponsorsDisabled", false);

    this.$root.$on('sponsorChanged', (v) => {
      // reset filters
      this.filters_store.protocol_id.value = null
      this.filters_store.crf.value = null
      this.filters_store.patient_id.value = null
      this.filters_store.status.value = null
      this.getData();
    });
  },
  mounted() {
    this.getData();
  },
  methods: {
    //issue 257 services
    formatDate(x)
    {
      return moment(new Date(x)).format('DD-MMM-YYYY')
    }
    ,
    //issue 257 services
    openAuditTrail (item) {
      this.auditTrail.entityId = item.id
      this.auditTrail.open = true
    },
    getData() {
      this.loading = true;
      const filters = JSON.parse(JSON.stringify(this.filters));
      getList(normalizeFilters(filters), this.pagination).then(data => {
        this.items = data.data;
        this.pagination.rowsPerPage = data.perPage;
        this.pagination.page = data.currentPage;
        this.pagination.totalItems = data.tot;
        this.totalItems = data.tot;
        this.loading = false;
      });
    },
    filterChanged(filter) {
      this.getData();
    },
    sortAlias(col) {
      return this.paginationAlias[col] || col;
    },
    changeSort(column) {
      column = this.sortAlias(column);
      const oldPagination = JSON.parse(JSON.stringify(this.pagination));
      oldPagination.page = 1;
      if (oldPagination.sortBy === column) {
        oldPagination.descending = !oldPagination.descending;
      } else {
        oldPagination.sortBy = column;
        oldPagination.descending = true;
      }
      this.pagination = oldPagination;
    },
    upsertPage(item) {
      this.$store.commit('app/spmItem', item);
      this.$router.push('/spm/' + item.id);
    },
    newSpmEvent() {
      this.$store.commit('app/spmItem', {});
      this.$router.push('/spm');
    },
    canDelete(item) {
      return this.$can('delete', subject('spm', item));
    },
    confirmDelete(item) {
      this.selectedItem = item;
      this.confirm_delete_dialog = true;
    },
    closeDelete() {
      this.selectedItem = {};
      this.confirm_delete_dialog = false;
    },
    remove() {
      upsert(
        {
          id: this.selectedItem.id,
          canceled_note: this.selectedItem.canceled_note,
          status: 'Canceled'
        }
      ).then(() => {
        // remove(this.selectedItem.id).then( id => {
        this.closeDelete();
        this.getData();
        this.$store.dispatch("app/openSnackbar", {
          message: "SPM report deleted successfully",
          color: "success"
        });
      }).catch(errorData => {
        this.$store.dispatch("app/openSnackbar", {
          message: "SPM report Delete error : " + errorData.message,
          color: "error"
        });
      });
    },
    exportExcel() {
      this.$store.dispatch("app/startLoading");
      const filters = JSON.parse(JSON.stringify(this.filters));
      exportExcelSpm(normalizeFilters(filters)).then(d => {

      }).finally(() => {
        this.$store.dispatch("app/stopLoading");
      });
    },
    reportQualityCheck() {
      this.$store.dispatch("app/startLoading");
      const filters = JSON.parse(JSON.stringify(this.filters));
      reportQualityCheck(normalizeFilters(filters), 'spm').then(d => {

      }).finally(() => {
        this.$store.dispatch("app/stopLoading");
      });
    },
    canceledClass(item) {
      return item.status == 'Canceled' ? 'canceled' : '';
    }
  }
};
</script>

<style lang="scss">
#spm_dataTable {
  .v-datatable__actions {
    color: black;

    .v-btn__content {
      color: black;
    }

    .v-btn {
      background-color: rgb(241, 241, 241);
    }
  }

  tr.lighten-3 th {
    padding: 0px 5px 0px 5px;
  }

  .unread td {
    font-weight: bold;
    background: #ffffff;
  }

  .canceled {
    text-decoration: line-through
  }
}
</style>

<style>
.spm_list .v-select__selection--comma {
  max-width: 100px !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}

.spmList .v-card--material__header {
  padding: 0px 10px 0px 0px !important;
}
</style>